import React from 'react'

import Header from '../../common/components/Header'
import SigEventsDetailsPager from './SigEventsDetailsPager'
import SigEventsDetailsHeader from './SigEventsDetailsHeader'
import SigEventsDetails from './SigEventsDetails'

import styles from './SigEventDetails.module.css'

const SigEventsDetailsPanel = () => {
  return (
    <div className={styles.panel}>
      <Header>Details</Header>
      <SigEventsDetailsHeader />
      <SigEventsDetails />
      <SigEventsDetailsPager />
    </div>
  )
}
export default SigEventsDetailsPanel
